export default "__VITE_ASSET__aca37654__"